"use client"
import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { Project } from '@/data/projects';
import { fadeInUp, staggerContainer, scaleOnHover } from '../animations';

interface ProjectScreenshotsProps {
  project: Project;
}

export const ProjectScreenshots: React.FC<ProjectScreenshotsProps> = ({ project }) => {
  if (!project.screenshots?.length) return null;

  return (
    <motion.div {...fadeInUp} className="mb-16">
      <h2 className="text-2xl font-bold text-white mb-6">Project Screenshots</h2>
      <motion.div
        className="grid md:grid-cols-2 gap-8"
        variants={staggerContainer}
        initial="initial"
        animate="animate"
      >
        {project.screenshots.map((screenshot, index) => (
          <motion.div
            key={index}
            className="bg-white/5 p-6 rounded-lg"
            variants={fadeInUp}
            whileHover={scaleOnHover.hover}
            transition={scaleOnHover.transition}
          >
            <motion.div
              className="relative h-64 mb-4"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.2 }}
            >
              <Image
                src={screenshot.image}
                alt={screenshot.alt}
                fill
                className="object-cover rounded-lg"
              />
            </motion.div>
            <h3 className="text-xl font-semibold text-white mb-2">{screenshot.title}</h3>
            <p className="text-gray-300">{screenshot.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}; 